import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IconComponent } from '@app/components/shared/icon/icon.component';
import { IconName } from '@app/utils/enums/icon-enum';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SnackbarService } from '@app/services/snackbar/snackbar.service';

@Component({
  selector: 'app-snackbar',
  standalone: true,
  imports: [IconComponent, TranslateModule, CommonModule],
  templateUrl: './snackbar.component.html',
  styleUrl: './snackbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SnackbarComponent {
  protected readonly snackbarService = inject(SnackbarService);
  protected readonly notifications = this.snackbarService.notifications;
  protected readonly IconName = IconName;

  public handleRemove(id: string): void {
    this.snackbarService.removeNotification(id);
  }
}
